export default class CoursesToggle {
  constructor(el) {
    this.el = el;
    this.isOpen = this.el.classList.contains('is-collapsed') ? false : true;
    this.tbody = this.el.querySelector('tbody');
    this.div = this.el.nextElementSibling;
    this.setContentElement();
  }

  setContentElement() {
    if (this.el.tagName === 'TABLE') {
      const caption = this.el.querySelector('caption');
      caption.addEventListener('click', this.toggle.bind(this));
      this.content = this.tbody;
    } else {
      this.el.addEventListener('click', this.toggle.bind(this));
      this.content = this.div;
    }
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.content.style.display = 'table';
    this.isOpen = true;
    this.el.classList.remove('is-collapsed')
  }

  close() {
    this.content.style.display = 'none';
    this.el.classList.add('is-collapsed')
    this.isOpen = false;
  }
}
